define([
    "dojo/_base/declare",
    "mw-form/Menu",
    "../mixins/property/TypeMixin",
    "../mixins/ScrollbarMixin",
    "mw-form/mixins/mixinDependencyValidator"
], function (declare, Menu, TypeMixin, ScrollbarMixin, mixinDependencyValidator) {

    return declare(mixinDependencyValidator.validate([Menu, TypeMixin, ScrollbarMixin]), {
        visualFamily: "default",

        postCreate: function () {
            this.inherited(arguments);
            this.domNode.setAttribute("data-focus", "temporary");
            this.domNode.classList.add("toolstrip");
        },

        _handleWidthOverflow: function () {
            this.domNode.style.maxWidth = "";
            if (this._invokingWidget && this._invokingWidget.domNode) {// Only handling the scenarios where we have an aroundNode
                // Check if width is overflowing and set maxWidth.
                // Using a similar logic that dojo uses to calculate maxHeight (in Dojo/Popup.js)
                var aroundNode = this._invokingWidget.domNode;
                var popupPos = this.domNode.getBoundingClientRect();
                var aroundPos = aroundNode.getBoundingClientRect();
                var maxWidth = Math.floor(Math.max(aroundPos.x, window.innerWidth - aroundPos.right));

                if (popupPos.width > maxWidth) {
                    this.domNode.style.maxWidth = (maxWidth - 1) + 'px'; // subtract 1px so the right (or left) border does not appear as clipped
                }
            }
        },

        _updateHeight: function () {
            // Fix for g2038745: check if popup is wider than the available screen size and specify
            // max-width so it does not get clipped
            this._handleWidthOverflow();
            this.inherited(arguments);
        }
    });
});
